import React from 'react';
import Select from 'react-select';

const DeliveryModal = ({ isOpen, setIsOpen, handleSubmit, handleChange, handleSelectChange, delivery, statusOptions, loadButton }) => {
    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay">
            <div className="custom-modal-content">
                <h2 className="oms-modal-title">Delivery details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label className="oms-form-label">Min Kilometer</label>
                        <input
                            type="number"
                            name="min_kilometer"
                            value={delivery.min_kilometer}
                            onChange={handleChange}
                            placeholder="e.g., 0.5"
                            step="0.1"
                            onWheel={(e) => e.target.blur()}
                            required
                        />
                    </div>

                    <div className="oms-form-group">
                        <label className="oms-form-label">Max Kilometer</label>
                        <input
                            type="number"
                            name="max_kilometer"
                            value={delivery.max_kilometer}
                            onChange={handleChange}
                            placeholder="e.g., 5"
                            step="0.1"
                            onWheel={(e) => e.target.blur()}
                            required
                        />
                    </div>

                    <div className="oms-form-group">
                        <label className="oms-form-label">Delivery Price</label>
                        <input
                            type="number"
                            name="delivery_price"
                            value={delivery.delivery_price}
                            onChange={handleChange}
                            placeholder="e.g., 100"
                            onWheel={(e) => e.target.blur()}
                            required
                        />
                    </div>

                    <div className="oms-form-group">
                        <label className="oms-form-label">Status</label>
                        <Select
                            options={statusOptions}
                            value={delivery.status}
                            onChange={handleSelectChange}
                            placeholder="Select Status"
                        />
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        {
                            loadButton ?<button type="button">Submiting...</button>:
                            <button type="submit">Submit</button>
                        }
                        
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DeliveryModal;
